// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_automation_hub_ui_styles" + "." + "2cdc6c0a" + ".chunk.css";
};